import { Grid } from "@material-ui/core";
import {
  Modal,
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import { useSelectOptionPost } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
export const urlUpdateBarang = LIST_URL_WAREHOUSE.adjustmentLGS.updateBarang;
export const urlDeleteBarang = LIST_URL_WAREHOUSE.adjustmentLGS.deleteBarang;
export const RESET_STATE_DAFTAR_BARANG = {
  adjusment_id: "",
  barang_id: "",
  qty: "",
  name: "",
  status_id: null,
  statuspengeluaran: "Pilih Status",
};

export const deleteBarangAdjusmentById = async (id) => {
  try {
    const res = await instance4.post(urlDeleteBarang, {
      id,
    });

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Data Berhasil Dihapus",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "30px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "10%",
  },
  // {
  //   id: "stokAsli",
  //   disablePadding: false,
  //   label: "STOK",
  //   align: "center",
  //   minWidth: "10%",
  // },
  {
    id: "qty",
    disablePadding: false,
    label: "STOK",
    align: "center",
    minWidth: "10%",
  },
  // {
  //   id: "stokSelisih",
  //   disablePadding: false,
  //   label: "SELISIH",
  //   align: "center",
  //   minWidth: "10%",
  // },
  {
    id: "hargapokok",
    disablePadding: false,
    label: "HARGA SATUAN",
    align: "center",
    minWidth: "10%",
  },
  {
    id: "total_harga",
    disablePadding: false,
    label: "TOTAL",
    align: "center",
    minWidth: "10%",
  },
];

export const ModalDaftarBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewData,
  label = "Tambah Barang",
  setNewAllData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formBarang.barang_id)) {
        defaultToastError("Barang tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        if (isNull(formBarang.status_id)) {
          defaultToastError("Harap pilih status barang!");
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        } else {
          const api = await instance4.post(urlUpdateBarang, {
            ...formBarang,
          });
          const res = await api?.data;
          if (res.status === 200) {
            defaultToastSuccess(res?.message);
            setShowModal(false);
            await setNewData();
            await setNewAllData();
          } else {
            defaultToastError(res.message);
          }
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const dataStatus = useSelectOptionPost(
    true,
    LIST_URL_WAREHOUSE.statusPengeluaranBarangLGS.get,
    TYPE_INSTANCE4
  );

  return (
    <Modal title={label} show={setShowModal} width='30%'>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <p className='mt-1 mb-1'>{formBarang.name}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formBarang.barang_id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name='qty'
              label='BANYAK'
              id='qty'
              value={formBarang.qty}
              onChange={handleChange("qty")}
              placeholder='Banyak'
            />
          </Grid>
          <Grid item sm={6}>
            <InputOptionMaster
              name='status'
              label='STATUS'
              id='status'
              withSearch={true}
              data={dataStatus}
              value={formBarang?.status_id}
              labelValue={formBarang?.statuspengeluaran}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormBarang({
                    ...formBarang,
                    status_id: null,
                    statuspengeluaran: "Pilih Status",
                  });
                } else {
                  setFormBarang({
                    ...formBarang,
                    status_id: e?.value,
                    statuspengeluaran: e?.label,
                  });
                }
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
